/// <reference path="../dts/jquery.d.ts" />

import { BMotionType, BMotionEnums } from "../Animations/BMotionEnums";
import { BMotion } from "../Animations/BMotion";
import { LinearBMotion } from "../Animations/LinearBMotion";
import { CurvilinearBMotion } from "../Animations/CurvilinearBMotion";
import { LinearPathBMotion } from "../Animations/LinearPathBMotion";
import { CurvilinearPathBMotion } from "../Animations/CurvilinearPathBMotion";
import { RotationBMotion } from "../Animations/RotationBMotion";
import { RevolutionBMotion } from "../Animations/RevolutionBMotion";
import { SwingBMotion } from "../Animations/SwingBMotion";
import { ScaleBMotion } from "../Animations/ScaleBMotion";
import { FadeEffect } from "../Effects/FadeEffect";
import { StringUtils } from "../Misc/Utils";

export class MotionPropertyUI {
    private motionType : BMotionType = 0
    private motionId : string
    private id : string = ""

    //Labels
    public static LABEL_ENDPOS_X = "ex";
    public static LABEL_ENDPOS_Y = "ey";
    public static LABEL_FRAMES_PER_LOOP = "fpl";
    public static LABEL_LOOP_COUNT = "lc";
    public static LABEL_START_FRAME = "sf";
    public static LABEL_END_FRAME = "ef";
    public static LABEL_ANCHOR_X = "ax";
    public static LABEL_ANCHOR_Y = "ay";
    public static LABEL_RADIUS_X = "rx";
    public static LABEL_RADIUS_Y = "ry";
    public static LABEL_ANGLE_START = "as";
    public static LABEL_ANGLE_END = "ae";
    public static LABEL_ZOOM_X = "zx";
    public static LABEL_ZOOM_Y = "zy";
    public static LABEL_OFFSET = "offset";
    public static LABEL_COUNTER_CLOCKWISE = "cc";
    public static LABEL_START_ALPHA = "sa";
    public static LABEL_END_ALPHA = "ea";

    public static LABEL_EASE_IN_OUT = "easeio";
    public static LABEL_BACK_AND_FORTH = "backAndForth";
    public static LABEL_DIRECTION = "dir";

    public static VALUE_BACK_AND_FORTH = 1;
    public static VALUE_ONE_WAY = 0;

    public static VALUE_DIR_FORWARD = 1;
    public static VALUE_DIR_BACKWARD = 0;

    public static VALUE_EASING_IN_OUT = 1;
    public static VALUE_EASING_NONE = 0;
    

    private static baseId = "prop-motions";
    
    constructor( motionId : string){
        this.motionId = motionId;
        //this.Jquery =  $('<div>');
        this.generateId();
        //console.log("constr "+this.Id+" : "+this.Jquery);
    }

    public addNew(motionType : BMotionType) : void{
        this.motionType = motionType;

        this.prepareDiv();
        this.addMotionNameText();
        this.addDeleteIcon();
        this.addDivider();
        
        this.addFrameRange();
        this.addBreak();
        this.addFramesPerLoop();
        this.addBreak();
        this.addLoopCount();
        this.addBreak();
        
        this.addMotionSpecificUI(this.motionType);
        
        this.addDivider();
        this.addEaseInOutCheckBox();
        this.addDivider();
        this.addDirection();
        //console.log("jquery out:"+this.Jquery);
        //return this.Jquery;
    }

    public remove(){
        $('#'+this.id).remove();
    }

    public update(motionObj : BMotion){
        if(motionObj){
            this.commonUpdate(motionObj);

            switch(motionObj.TYPE){
                case BMotionType.LIBM:
                    this.motionType = BMotionType.LIBM;
                    this.updateLIBM(motionObj as LinearBMotion);
                    break;
                case BMotionType.CUBM:
                    this.motionType = BMotionType.CUBM;
                    this.updateCUBM(motionObj as CurvilinearBMotion);
                    break;
                case BMotionType.LIPATH:
                    this.motionType = BMotionType.LIPATH;
                    this.updateLIPATH(motionObj as LinearPathBMotion);
                    break;
                case BMotionType.CUPATH:
                    this.motionType = BMotionType.CUPATH;
                    this.updateCUPATH(motionObj as CurvilinearPathBMotion);
                    break;
                case BMotionType.ROTA:
                    this.motionType = BMotionType.ROTA;
                    this.updateROTA(motionObj as RotationBMotion);
                    break;
                case BMotionType.REVO:
                    this.motionType = BMotionType.REVO;
                    this.updateREVO(motionObj as RevolutionBMotion);
                    break;
                case BMotionType.SWING:
                    this.motionType = BMotionType.SWING;
                    this.updateSWING(motionObj as SwingBMotion);
                    break;
                case BMotionType.SCALE:
                    this.motionType = BMotionType.SCALE;
                    this.updateSCALE(motionObj as ScaleBMotion);
                    break;
                case BMotionType.FADE:
                    this.motionType = BMotionType.FADE;
                    this.updateFADE(motionObj as FadeEffect);
                    break;
            }
        }
    }

    private addMotionSpecificUI(motionType : BMotionType){
        switch(motionType){
            case BMotionType.LIBM:            
                this.addEndPos();
                break;
            case BMotionType.CUBM:
                this.addEndPos();
                this.addBreak();
                this.addAnchor();
                break;
            case BMotionType.LIPATH:
                break;
            case BMotionType.CUPATH:
                break;
            case BMotionType.ROTA:
                this.addAnchor();
                this.addDivider();
                this.addCounterClockwiseCheckbox();
                break;
            case BMotionType.REVO:
                this.addAnchor();
                this.addBreak();
                this.addRadiusXY();
                this.addBreak();
                this.addOffset();
                this.addDivider();
                this.addCounterClockwiseCheckbox();
                break;
            case BMotionType.SWING:
                this.addAnchor();
                this.addBreak();
                this.addAngles();
                this.addDivider();
                this.addCounterClockwiseCheckbox();
                break;
            case BMotionType.SCALE:
                this.addZoomXY();
                this.addBreak();
                this.addAnchor();
                break;
            case BMotionType.FADE:
                this.addOpacity();
                break;
        }
    }

    private generateId(){
        this.id = MotionPropertyUI.baseId + "-" + this.motionId;
    }

    private getLabelId(label : string) : string{
        return '#'+this.id+'-'+label;
    }

    //====NEW UI METHODS===

    private prepareDiv(){
        /*this.Jquery.attr("id", this.Id);
        this.Jquery.attr("class", "ui segment");
        console.log("prep div:"+this.Jquery);
        */
        var html = $('<div>');
        html.attr("id", this.id);
        html.attr("class", "ui segment");
        $("#prop-motions").append(html);
    }

    private addMotionNameText(){
        //this.Jquery.text("Linear Motion");
        $("#"+this.id).text(StringUtils.capitalizeFirstLetter(this.motionId) + " ("+BMotionEnums.getBMotionName(this.motionType)+")");
    }

    private addDeleteIcon(){
        var button = $('<button>');
        button.attr('class', "ui compact icon button");
        button.attr('onclick', "UIEvents.deleteMotion('"+this.motionId+"')");
        button.attr('style', "float:right");
        button.html('<i class="trash outline icon"></i>');
        /* Result is :
        <button class="ui compact icon button" onclick="UIEvents.deleteMotion(1)" style="float:right">
            <i class="trash outline icon"></i>
        </button>
        */

        //this.Jquery.add(button);
        $("#"+this.id).append(button);
    }

    private addEndPos(){
        //this.Jquery.add("End Posiiton:");
        $("#"+this.id).append("End Position:");
        //this.Jquery.add("X");
        $("#"+this.id).append("X");
        this.addTextInput(MotionPropertyUI.LABEL_ENDPOS_X);
        //this.Jquery.add("Y");
        $("#"+this.id).append("Y");
        this.addTextInput(MotionPropertyUI.LABEL_ENDPOS_Y);
    }

    private addFramesPerLoop(){
        //this.Jquery.add("Duration :");
        $("#"+this.id).append("Frames per loop:");
        this.addTextInput(MotionPropertyUI.LABEL_FRAMES_PER_LOOP);
        /*<div class="ui mini input">
            <input id="prop-motions-libm-dur" type="text" placeholder="0" style="width:100px"/>
        </div>*/
        //this.Jquery.add("frames per loop");
        //$("#"+this.id).append("frames per loop");
    }

    private addLoopCount(){
        $("#"+this.id).append("Repeat ");
        this.addTextInput(MotionPropertyUI.LABEL_LOOP_COUNT);
        $("#"+this.id).append(" times");
    }

    private addFrameRange(){
        $("#"+this.id).append("Start Frame");
        this.addTextInput(MotionPropertyUI.LABEL_START_FRAME);
        $("#"+this.id).append(" End Frame");
        this.addTextInput(MotionPropertyUI.LABEL_END_FRAME);
    }

    private addAnchor(){
        $("#"+this.id).append("Anchor:");
        $("#"+this.id).append(" X");
        this.addTextInput(MotionPropertyUI.LABEL_ANCHOR_X);
        $("#"+this.id).append(" Y");
        this.addTextInput(MotionPropertyUI.LABEL_ANCHOR_Y);
    }

    private addRadiusXY(){
        $("#"+this.id).append("Radius:");
        $("#"+this.id).append(" X");
        this.addTextInput(MotionPropertyUI.LABEL_RADIUS_X);
        $("#"+this.id).append(" Y");
        this.addTextInput(MotionPropertyUI.LABEL_RADIUS_Y);    
    }

    private addAngles(){
        $("#"+this.id).append("Angle:");
        $("#"+this.id).append(" Start");
        this.addTextInput(MotionPropertyUI.LABEL_ANGLE_START);
        $("#"+this.id).append(" End");
        this.addTextInput(MotionPropertyUI.LABEL_ANGLE_END);        
    }

    private addZoomXY(){
        $("#"+this.id).append("Zoom Factor:");
        $("#"+this.id).append(" W");
        this.addTextInput(MotionPropertyUI.LABEL_ZOOM_X);
        $("#"+this.id).append(" H");
        this.addTextInput(MotionPropertyUI.LABEL_ZOOM_Y);        
    }

    private addCounterClockwiseCheckbox(){
        this.addCheckbox(MotionPropertyUI.LABEL_COUNTER_CLOCKWISE, "Counter Clockwise");
    }

    private addEaseInOutCheckBox(){
        /*<div id="prop-visibilityBtn" class="ui checkbox">
                <input type="checkbox" checked="" name="visibility">
                <label>Visible</label>
            </div>
        */
        this.addCheckbox(MotionPropertyUI.LABEL_EASE_IN_OUT, "Ease In Ease Out");
    }

    private addDirection(){
        //$("#"+this.id).append("Direction:");
        this.addCheckbox(MotionPropertyUI.LABEL_DIRECTION, "Back & Forth");
    }

    private addOffset(){
        $("#"+this.id).append("Offset:");
        this.addTextInput(MotionPropertyUI.LABEL_OFFSET);
        $("#"+this.id).append("radian");
    }

    private addOpacity(){
        $("#"+this.id).append("Opacity:");
        $("#"+this.id).append(" Start");
        this.addTextInput(MotionPropertyUI.LABEL_START_ALPHA);
        $("#"+this.id).append(" End");
        this.addTextInput(MotionPropertyUI.LABEL_END_ALPHA);  
    }

    //====BASIC UI METHODS====

    private addDivider(){
        //this.Jquery.add('<div class="ui divider"></div>');
        $("#"+this.id).append('<div class="ui divider"></div>');
    }

    private addTextInput(label : string){
        var textInput = $('<div>');
        textInput.attr('class',"ui mini input horizontalSpace");
        textInput.html(`<input id="${this.id}-${label}" type="text" placeholder="0" style="width:50px" oninput="UIEvents.onBMotionInputValueChange('${this.id}-${label}','${this.motionId}','${label}');"/>`);
        //this.Jquery.add(textInput);
        $("#"+this.id).append(textInput);
        /*
        <div class="ui mini input">
            <input id="prop-motions-libm-x" type="text" placeholder="0" style="width:80px"/>
        </div>
        */
    }

    private addCheckbox(label : string, desc : string){
        var checkbox = $('<div>');
        checkbox.attr('class','ui checkbox horizontalSpace');
        checkbox.attr('onchange',`UIEvents.onBMotionInputValueChange('${this.id}-${label}','${this.motionId}','${label}');`);
        checkbox.html(`<input id="${this.id}-${label}" type="checkbox"><label>${desc}</label>`);
        $("#"+this.id).append(checkbox);
    }

    private addBreak(){
        //this.Jquery.add("<div></div>");
        $("#"+this.id).append("<div class='verticalSpace'></div>");
    }

    //==UPDATE METHODS

    private commonUpdate(motion : BMotion){
        $(this.getLabelId(MotionPropertyUI.LABEL_FRAMES_PER_LOOP)).val(motion.getFramesPerLoop());
        $(this.getLabelId(MotionPropertyUI.LABEL_LOOP_COUNT)).val(motion.getLoops());
        $(this.getLabelId(MotionPropertyUI.LABEL_START_FRAME)).val(motion.getFrameRange()[0]);
        $(this.getLabelId(MotionPropertyUI.LABEL_END_FRAME)).val(motion.getFrameRange()[1]);

        if(motion.getEaseInEaseOut()){
            $(this.getLabelId(MotionPropertyUI.LABEL_EASE_IN_OUT)).attr('checked','true');
        }else{
            $(this.getLabelId(MotionPropertyUI.LABEL_EASE_IN_OUT)).removeAttr('checked');
        }

        if(motion.getBackAndForth()){
            $(this.getLabelId(MotionPropertyUI.LABEL_DIRECTION)).attr('checked','true');
        }else{
            $(this.getLabelId(MotionPropertyUI.LABEL_DIRECTION)).removeAttr('checked');
        }
    }

    private updateLIBM(motion : LinearBMotion){
        $(this.getLabelId(MotionPropertyUI.LABEL_ENDPOS_X)).val(motion.getEndPos()[0]);
        $(this.getLabelId(MotionPropertyUI.LABEL_ENDPOS_Y)).val(motion.getEndPos()[1]);
    }
    
    private updateCUBM(motion : CurvilinearBMotion){
        $(this.getLabelId(MotionPropertyUI.LABEL_ENDPOS_X)).val(motion.getEndPos()[0]);
        $(this.getLabelId(MotionPropertyUI.LABEL_ENDPOS_Y)).val(motion.getEndPos()[1]);
        
        $(this.getLabelId(MotionPropertyUI.LABEL_ANCHOR_X)).val(motion.getAnchorPos()[0]);
        $(this.getLabelId(MotionPropertyUI.LABEL_ANCHOR_Y)).val(motion.getAnchorPos()[1]);
    }
    
    private updateLIPATH(motion : LinearPathBMotion){
        
    }

    private updateCUPATH(motion : CurvilinearPathBMotion){
        
    }

    private updateROTA(motion : RotationBMotion){
        $(this.getLabelId(MotionPropertyUI.LABEL_ANCHOR_X)).val(motion.getAnchorPos()[0]);
        $(this.getLabelId(MotionPropertyUI.LABEL_ANCHOR_Y)).val(motion.getAnchorPos()[1]);
        
        if(motion.isCounterClockwise()){
            $(this.getLabelId(MotionPropertyUI.LABEL_COUNTER_CLOCKWISE)).attr('checked','true');
        }else{
            $(this.getLabelId(MotionPropertyUI.LABEL_COUNTER_CLOCKWISE)).removeAttr('checked');
        }
    }

    private updateREVO(motion : RevolutionBMotion){
        $(this.getLabelId(MotionPropertyUI.LABEL_ANCHOR_X)).val(motion.getAnchorPos()[0]);
        $(this.getLabelId(MotionPropertyUI.LABEL_ANCHOR_Y)).val(motion.getAnchorPos()[1]);
        
        $(this.getLabelId(MotionPropertyUI.LABEL_RADIUS_X)).val(motion.getRadius()[0]);
        $(this.getLabelId(MotionPropertyUI.LABEL_RADIUS_Y)).val(motion.getRadius()[1]);

        $(this.getLabelId(MotionPropertyUI.LABEL_OFFSET)).val(motion.getOffsetRadian());

        if(motion.isCounterClockwise()){
            $(this.getLabelId(MotionPropertyUI.LABEL_COUNTER_CLOCKWISE)).attr('checked','true');
        }else{
            $(this.getLabelId(MotionPropertyUI.LABEL_COUNTER_CLOCKWISE)).removeAttr('checked');
        }
    }

    private updateSWING(motion : SwingBMotion){
        $(this.getLabelId(MotionPropertyUI.LABEL_ANCHOR_X)).val(motion.getAnchorPos()[0]);
        $(this.getLabelId(MotionPropertyUI.LABEL_ANCHOR_Y)).val(motion.getAnchorPos()[1]);
        
        $(this.getLabelId(MotionPropertyUI.LABEL_ANGLE_START)).val(motion.getAngles()[0]);
        $(this.getLabelId(MotionPropertyUI.LABEL_ANGLE_END)).val(motion.getAngles()[1]);

        if(motion.isCounterClockwise()){
            $(this.getLabelId(MotionPropertyUI.LABEL_COUNTER_CLOCKWISE)).attr('checked','true');
        }else{
            $(this.getLabelId(MotionPropertyUI.LABEL_COUNTER_CLOCKWISE)).removeAttr('checked');
        }
    }

    private updateSCALE(motion : ScaleBMotion){ 
        $(this.getLabelId(MotionPropertyUI.LABEL_ZOOM_X)).val(motion.getScaleFactor()[0]);
        $(this.getLabelId(MotionPropertyUI.LABEL_ZOOM_Y)).val(motion.getScaleFactor()[1]);

        $(this.getLabelId(MotionPropertyUI.LABEL_ANCHOR_X)).val(motion.getAnchorPos()[0]);
        $(this.getLabelId(MotionPropertyUI.LABEL_ANCHOR_Y)).val(motion.getAnchorPos()[1]);
    }

    private updateFADE(motion : FadeEffect){
        $(this.getLabelId(MotionPropertyUI.LABEL_START_ALPHA)).val(motion.getStartAlpha());
        $(this.getLabelId(MotionPropertyUI.LABEL_END_ALPHA)).val(motion.getEndAlpha());
    }
}